export const I18n = {
	'en': {
		sure: 'Are you sure to delete the app ?',
		cancel: 'Cancel',
		delete: 'Delete',
		source: 'Source:',
		destination: 'Destination:',
		clearSelection: 'Clear Selection',
		save: 'Save',
		required: 'Required',
		searchPlaceholder: 'Search by Name'
	},
	'ru': {
		sure: 'Вы хотите удалить приложение ?',
		cancel: 'Отмена',
		delete: 'Удалить',
		source: 'Источник:',
		destination: 'Назначение:',
		clearSelection: 'Очистить выбор',
		save: 'Сохранить',
		required: 'Обязательный к установке',
		searchPlaceholder: 'Поиск по имени'
	},
	'sk': {
		sure: 'Naozaj chcete odstrániť aplikácie?',
		cancel: 'Zrušiť',
		delete: 'Vymazať',
		source: 'Zdroj:',
		destination: 'Destinácia:',
		clearSelection: 'Čistý výber',
		save: 'Uložiť',
		required: 'Povinná inštalácia',
		searchPlaceholder: 'Vyhľadávanie podľa mena'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/packManager/index.js